// extracted by mini-css-extract-plugin
export var modalFooter = "_sa-0";